import { cva } from "class-variance-authority"
import PropTypes from "prop-types"
import { forwardRef } from "react"

import { cn } from "styles/utils"

const toggleVariants = cva(
  [
    "relative",
    "rounded-full",
    "bg-grey-20",
    "duration-300",
    "transition-all",
    "peer-checked:bg-primary",
    "before:absolute",
    "before:rounded-full",
    "before:bg-white",
    "before:shadow-xs",
    "before:shadow-grey-35",
    "before:duration-300",
    "before:transition-all",
  ],
  {
    defaultVariants: {
      sz: "default",
    },
    variants: {
      sz: {
        default: [
          "h-20 w-36",
          "before:left-0 before:top-0",
          "before:h-20 before:w-20",
          "peer-checked:before:translate-x-17",
        ],
      },
    },
  }
)

const Switch = forwardRef(
  ({ children, containerClassName, toggleClassName, ...props }, ref) => {
    return (
      <label
        className={cn(
          "focus-within:outline-primary inline-flex cursor-pointer items-center gap-8 focus-within:outline-2 focus-within:outline-offset-2",
          containerClassName
        )}
      >
        <div className="relative">
          <input
            className="peer sr-only"
            ref={ref}
            role="switch"
            type="checkbox"
            {...props}
          />
          <div
            aria-hidden
            className={cn(toggleVariants({ className: toggleClassName }))}
          />
        </div>
        {children}
      </label>
    )
  }
)

Switch.propTypes = {
  children: PropTypes.node,
  containerClassName: PropTypes.string,
  // sz: PropTypes.oneOf(["default", "sm"]),
  toggleClassName: PropTypes.string,
}

Switch.defaultProps = {
  sz: "default",
}

Switch.displayName = "Switch"

export default Switch
